/**
 * Application shell.
 */

import React from 'react';
import { useTheme, fontFamily, spacing } from '@fti/design-system';
import { useAuth } from './auth/hooks';
import { AppHeader } from './components/AppHeader';
import { QuoteExtractorPage } from './pages/QuoteExtractor/QuoteExtractorPage';

export const App: React.FC = () => {
  const auth = useAuth();
  const { theme, setTheme } = useTheme();

  React.useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: `linear-gradient(180deg, ${theme.colors.primary[50]} 0%, ${theme.colors.background.default} 320px)`,
        color: theme.colors.text.primary,
        fontFamily: fontFamily.sans,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      }}
    >
      <AppHeader />
      <main
        style={{
          maxWidth: '1080px',
          margin: '0 auto',
          padding: `${spacing.xl} ${spacing.xl} ${spacing['2xl'] ?? spacing.xl}`,
        }}
      >
        {auth.isAuthenticated ? (
          <QuoteExtractorPage />
        ) : (
          <p
            style={{
              fontSize: '1rem',
              color: theme.colors.text.secondary,
              textAlign: 'center',
              marginTop: spacing['2xl'] ?? spacing.xl,
            }}
          >
            Sign in to extract quotable statements.
          </p>
        )}
      </main>
    </div>
  );
};
